<template>
  <div>
    <div class="page-title">新申請 New Admission</div>
    <div class="application-detail">
      <template v-if="stage !== 0">
        <div v-if="!isEdit" style="white-space: pre-wrap;" class="fs-title">
           {{ eventStatusDetail.title }}
        </div>
        <div v-else-if="applicationDetail.eventStatus" style="white-space: pre-wrap;" class="fs-title applicationDetail-title">
          <div class="registrationNo">Registration No {{ applicationDetail.registrationNo}}</div>
          <div>{{ applicationDetail.eventStatus.title }}</div>
        </div>
      </template>
      <admissions @onProceed="onProceed" v-if="stage == 0 && !isEdit">
        <div v-html="eventStatusDetail.applicationNode"></div>
      </admissions>
      <div class="application-content">
        <el-breadcrumb v-if="stage !== 0" separator-class="el-icon-arrow-right">
          <el-breadcrumb-item class="fill"
            >填寫資料 Fill in information</el-breadcrumb-item
          >
          <el-breadcrumb-item>上傳資料 Upload</el-breadcrumb-item>
        </el-breadcrumb>

        <div v-if="formType == 10">
          <ms1StudentParticular
            ref="studentParticularForm"
            @studentParticularSaveAndContinue="studentParticularSaveAndContinue"
            @studentParticularSave="studentParticularSave"
            v-if="stage == 1"
            :studentParticular="studentParticular"
          ></ms1StudentParticular>
           <ms1PersonalBackground
            v-if="stage == 2"
            :personalBackground="personalBackground"
          ></ms1PersonalBackground>
           <studentPerformance
            v-if="stage == 2"
            ref="studentPerformance"
            :applicationDetail="applicationDetail"
            :studentPerformance="studentPerformance"
            :eventStatusId='eventStatusId'
          ></studentPerformance>
          <ms1ParentParticular
            v-if="stage == 2"
            ref="parentParticular"
            :parentParticulars="parentParticularData"
          ></ms1ParentParticular>
          <ms1Declaration
            :declaration="declaration"
            @personalBackgroundSaveAndContinue="
              personalBackgroundSaveAndContinue
            "
            @personalBackgroundSave="personalBackgroundSave"
            @personalBackgroundBack="personalBackgroundBack"
            v-if="stage == 2"
          ></ms1Declaration>
          <ms1StudentFiles
            @onStudentFilesSaveAndSubmit="onStudentFilesSaveAndSubmit"
            @onStudentFilesSave="onStudentFilesSave"
            @onStudentFilesBack="onStudentFilesBack"
            v-if="stage == 3"
            :studentFiles="studentFiles"
          ></ms1StudentFiles>
        </div>
        <div v-if="formType == 8">
          <ds2StudentParticular
            ref="studentParticularForm"
            @studentParticularSaveAndContinue="studentParticularSaveAndContinue"
            @studentParticularSave="studentParticularSave"
            v-if="stage == 1"
            :studentParticular="studentParticular"
          ></ds2StudentParticular>
           <ds2PersonalBackground
            v-if="stage == 2"
            :personalBackground="personalBackground"
          ></ds2PersonalBackground>
           <studentPerformance
            v-if="stage == 2"
            ref="studentPerformance"
            :eventStatusId='eventStatusId'
            :applicationDetail="applicationDetail"
            :studentPerformance="studentPerformance"
          ></studentPerformance>
          <ds2ParentParticular
            v-if="stage == 2"
            ref="parentParticular"
            :parentParticulars="parentParticularData"
          ></ds2ParentParticular>
          <ds2Declaration
            :declaration="declaration"
            @personalBackgroundSaveAndContinue="
              personalBackgroundSaveAndContinue
            "
            @personalBackgroundSave="personalBackgroundSave"
            @personalBackgroundBack="personalBackgroundBack"
            v-if="stage == 2"
          ></ds2Declaration>
          <ds2StudentFiles
            @onStudentFilesSaveAndSubmit="onStudentFilesSaveAndSubmit"
            @onStudentFilesSave="onStudentFilesSave"
            @onStudentFilesBack="onStudentFilesBack"
            v-if="stage == 3"
            :studentFiles="studentFiles"
          ></ds2StudentFiles>
        </div>
        <div v-if="formType == 7">
          <ds1StudentParticular
            ref="studentParticularForm"
            @studentParticularSaveAndContinue="studentParticularSaveAndContinue"
            @studentParticularSave="studentParticularSave"
            v-if="stage == 1"
            :studentParticular="studentParticular"
          ></ds1StudentParticular>
           <ds1PersonalBackground
            v-if="stage == 2"
            :personalBackground="personalBackground"
          ></ds1PersonalBackground>
           <studentPerformance
            v-if="stage == 2"
            ref="studentPerformance"
            :eventStatusId='eventStatusId'
            :applicationDetail="applicationDetail"
            :studentPerformance="studentPerformance"
          ></studentPerformance>
          <ds1ParentParticular
            v-if="stage == 2"
            ref="parentParticular"
            :parentParticulars="parentParticularData"
          ></ds1ParentParticular>
          <ds1Declaration
            :declaration="declaration"
            @personalBackgroundSaveAndContinue="
              personalBackgroundSaveAndContinue
            "
            @personalBackgroundSave="personalBackgroundSave"
            @personalBackgroundBack="personalBackgroundBack"
            v-if="stage == 2"
          ></ds1Declaration>
          <ds1StudentFiles
            @onStudentFilesSaveAndSubmit="onStudentFilesSaveAndSubmit"
            @onStudentFilesSave="onStudentFilesSave"
            @onStudentFilesBack="onStudentFilesBack"
            v-if="stage == 3"
            :studentFiles="studentFiles"
          ></ds1StudentFiles>
        </div>
        <div v-if="formType == 6">
          <fsInterimStudentParticular
            ref="studentParticularForm"
            @studentParticularSaveAndContinue="studentParticularSaveAndContinue"
            @studentParticularSave="studentParticularSave"
            v-if="stage == 1"
            :studentParticular="studentParticular"
          ></fsInterimStudentParticular>
           <fsInterimPersonalBackground
            v-if="stage == 2"
            :personalBackground="personalBackground"
          ></fsInterimPersonalBackground>
           <studentPerformance
            v-if="stage == 2"
            :eventStatusId='eventStatusId'
            :applicationDetail="applicationDetail"
            ref="studentPerformance"
            :studentPerformance="studentPerformance"
          ></studentPerformance>
          <fsInterimParentParticular
            v-if="stage == 2"
            ref="parentParticular"
            :parentParticulars="parentParticularData"
          ></fsInterimParentParticular>
          <fsInterimDeclaration
            :declaration="declaration"
            @personalBackgroundSaveAndContinue="
              personalBackgroundSaveAndContinue
            "
            @personalBackgroundSave="personalBackgroundSave"
            @personalBackgroundBack="personalBackgroundBack"
            v-if="stage == 2"
          ></fsInterimDeclaration>
          <fsInterimStudentFiles
            @onStudentFilesSaveAndSubmit="onStudentFilesSaveAndSubmit"
            @onStudentFilesSave="onStudentFilesSave"
            @onStudentFilesBack="onStudentFilesBack"
            v-if="stage == 3"
            :studentFiles="studentFiles"
          ></fsInterimStudentFiles>
        </div>
        <div v-if="formType == 1">
          <fs2StudentParticular
            ref="studentParticularForm"
            @studentParticularSaveAndContinue="studentParticularSaveAndContinue"
            @studentParticularSave="studentParticularSave"
            v-if="stage == 1"
            :studentParticular="studentParticular"
          ></fs2StudentParticular>
           <fs2PersonalBackground
            v-if="stage == 2"
            :personalBackground="personalBackground"
          ></fs2PersonalBackground>
           <studentPerformance
            v-if="stage == 2"
            :eventStatusId='eventStatusId'
            :applicationDetail="applicationDetail"
            ref="studentPerformance"
            :studentPerformance="studentPerformance"
          ></studentPerformance>
          <fs2ParentParticular
            v-if="stage == 2"
            ref="parentParticular"
            :parentParticulars="parentParticularData"
          ></fs2ParentParticular>
          <fs2Declaration
            :declaration="declaration"
            @personalBackgroundSaveAndContinue="
              personalBackgroundSaveAndContinue
            "
            @personalBackgroundSave="personalBackgroundSave"
            @personalBackgroundBack="personalBackgroundBack"
            v-if="stage == 2"
          ></fs2Declaration>
          <fs2StudentFiles
            @onStudentFilesSaveAndSubmit="onStudentFilesSaveAndSubmit"
            @onStudentFilesSave="onStudentFilesSave"
            @onStudentFilesBack="onStudentFilesBack"
            v-if="stage == 3"
            :studentFiles="studentFiles"
          ></fs2StudentFiles>
        </div>
        <div v-if="formType == 0">
          <fsStudentParticular
            ref="studentParticularForm"
            @studentParticularSaveAndContinue="studentParticularSaveAndContinue"
            @studentParticularSave="studentParticularSave"
            v-if="stage == 1"
            :studentParticular="studentParticular"
          ></fsStudentParticular>
          <fsPersonalBackground
            v-if="stage == 2"
            :personalBackground="personalBackground"
          ></fsPersonalBackground>
          <fsParentParticular
            v-if="stage == 2"
            ref="parentParticular"
            :parentParticulars="parentParticularData"
          ></fsParentParticular>
          <fsDeclaration
            :declaration="declaration"
            @personalBackgroundSaveAndContinue="
              personalBackgroundSaveAndContinue
            "
            @personalBackgroundSave="personalBackgroundSave"
            @personalBackgroundBack="personalBackgroundBack"
            v-if="stage == 2"
          ></fsDeclaration>
          <fsStudentFiles
            @onStudentFilesSaveAndSubmit="onStudentFilesSaveAndSubmit"
            @onStudentFilesSave="onStudentFilesSave"
            @onStudentFilesBack="onStudentFilesBack"
            v-if="stage == 3"
            :studentFiles="studentFiles"
          ></fsStudentFiles>
        </div>
        <div v-if="formType == 9">
          <ds3StudentParticular
            ref="studentParticularForm"
            @studentParticularSaveAndContinue="studentParticularSaveAndContinue"
            @studentParticularSave="studentParticularSave"
            v-if="stage == 1"
            :studentParticular="studentParticular"
          ></ds3StudentParticular>
          
          <ds3PersonalBackground
            v-if="stage == 2"
            :personalBackground="personalBackground"
          ></ds3PersonalBackground>
           <studentPerformance
            v-if="stage == 2"
            :eventStatusId='eventStatusId'
            :applicationDetail="applicationDetail"
            ref="studentPerformance"
            :studentPerformance="studentPerformance"
          ></studentPerformance>
          <ds3ParentParticular
            v-if="stage == 2"
            ref="parentParticular"
            :parentParticulars="parentParticularData"
          ></ds3ParentParticular>
          <ds3Declaration
            :declaration="declaration"
            @personalBackgroundSaveAndContinue="
              personalBackgroundSaveAndContinue
            "
            @personalBackgroundSave="personalBackgroundSave"
            @personalBackgroundBack="personalBackgroundBack"
            v-if="stage == 2"
          ></ds3Declaration>
          <ds3StudentFiles
            @onStudentFilesSaveAndSubmit="onStudentFilesSaveAndSubmit"
            @onStudentFilesSave="onStudentFilesSave"
            @onStudentFilesBack="onStudentFilesBack"
            v-if="stage == 3"
            :studentFiles="studentFiles"
          ></ds3StudentFiles>
        </div>
        <div v-if="formType == 2">
          <ds4StudentParticular
            ref="studentParticularForm"
            @studentParticularSaveAndContinue="studentParticularSaveAndContinue"
            @studentParticularSave="studentParticularSave"
            v-if="stage == 1"
            :studentParticular="studentParticular"
          ></ds4StudentParticular>
          
          <ds4PersonalBackground
            v-if="stage == 2"
            :personalBackground="personalBackground"
          ></ds4PersonalBackground>
           <studentPerformance
            v-if="stage == 2"
            :eventStatusId='eventStatusId'
            :applicationDetail="applicationDetail"
            ref="studentPerformance"
            :studentPerformance="studentPerformance"
          ></studentPerformance>
          <ds4ParentParticular
            v-if="stage == 2"
            ref="parentParticular"
            :parentParticulars="parentParticularData"
          ></ds4ParentParticular>
          <ds4Declaration
            :declaration="declaration"
            @personalBackgroundSaveAndContinue="
              personalBackgroundSaveAndContinue
            "
            @personalBackgroundSave="personalBackgroundSave"
            @personalBackgroundBack="personalBackgroundBack"
            v-if="stage == 2"
          ></ds4Declaration>
          <ds4StudentFiles
            
            @onStudentFilesSaveAndSubmit="onStudentFilesSaveAndSubmit"
            @onStudentFilesSave="onStudentFilesSave"
            @onStudentFilesBack="onStudentFilesBack"
            v-if="stage == 3"
            :studentFiles="studentFiles"
          ></ds4StudentFiles>
        </div>
        <div v-if="formType == 3">
          <ds5StudentParticular
            ref="studentParticularForm"
            @studentParticularSaveAndContinue="studentParticularSaveAndContinue"
            @studentParticularSave="studentParticularSave"
            v-if="stage == 1"
            :studentParticular="studentParticular"
          ></ds5StudentParticular>
         
          <ds5PersonalBackground
            v-if="stage == 2"
            :personalBackground="personalBackground"
          ></ds5PersonalBackground>
          <studentPerformance
            v-if="stage == 2"
            :eventStatusId='eventStatusId'
            :applicationDetail="applicationDetail"
            ref="studentPerformance"
            :studentPerformance="studentPerformance"
          ></studentPerformance>
           <ds5ParentParticular
            v-if="stage == 2"
            ref="parentParticular"
            :parentParticulars="parentParticularData"
          ></ds5ParentParticular>
          <ds5Declaration
            :declaration="declaration"
            @personalBackgroundSaveAndContinue="
              personalBackgroundSaveAndContinue
            "
            @personalBackgroundSave="personalBackgroundSave"
            @personalBackgroundBack="personalBackgroundBack"
            v-if="stage == 2"
          ></ds5Declaration>
          <ds5StudentFiles
            @onStudentFilesSaveAndSubmit="onStudentFilesSaveAndSubmit"
            @onStudentFilesSave="onStudentFilesSave"
            @onStudentFilesBack="onStudentFilesBack"
            v-if="stage == 3"
            :studentFiles="studentFiles"
          ></ds5StudentFiles>
        </div>
        <div v-if="formType == 11">
          <ms3HkdseStudentParticular
            ref="studentParticularForm"
            @studentParticularSaveAndContinue="studentParticularSaveAndContinue"
            @studentParticularSave="studentParticularSave"
            v-if="stage == 1"
            :studentParticular="studentParticular"
          ></ms3HkdseStudentParticular>
         
          <ms3HkdsePersonalBackground
            v-if="stage == 2"
            :personalBackground="personalBackground"
          ></ms3HkdsePersonalBackground>
           <studentPerformance
            v-if="stage == 2"
            ref="studentPerformance"
            :eventStatusId='eventStatusId'
            :applicationDetail="applicationDetail"
            :studentPerformance="studentPerformance"
          ></studentPerformance>
           <ms3HkdseParentParticular
            v-if="stage == 2"
            ref="parentParticular"
            :parentParticulars="parentParticularData"
          ></ms3HkdseParentParticular>
          <ms3HkdseDeclaration
            :declaration="declaration"
            @personalBackgroundSaveAndContinue="
              personalBackgroundSaveAndContinue
            "
            @personalBackgroundSave="personalBackgroundSave"
            @personalBackgroundBack="personalBackgroundBack"
            v-if="stage == 2"
          ></ms3HkdseDeclaration>
          <ms3HkdseStudentFiles
            @onStudentFilesSaveAndContinue="onStudentFilesSaveAndContinue"
            @onStudentFilesSave="onStudentFilesSave"
            @onStudentFilesBack="onStudentFilesBack"
            v-if="stage == 3"
            :studentFiles="studentFiles"
          ></ms3HkdseStudentFiles>
          <ms3HkdseQuestionnaire
            @onQuestionnaireSaveAndContinue="onQuestionnaireSaveAndContinue"
            @onQuestionnaireSave="onQuestionnaireSave"
            @onQuestionnaireBack="onQuestionnaireBack"
            v-if="stage == 4"
            :questionnaire="questionnaire"
          ></ms3HkdseQuestionnaire>
          <ms3HkdseApplicantLanguage
            v-if="stage == 5"
            :applicantLanguage="applicantLanguage"
          ></ms3HkdseApplicantLanguage>
          <ms3HkdseSubjectsApplied
            @onSubjectsAppliedSaveAndSubmit="onSubjectsAppliedSaveAndSubmit"
            @onSubjectsAppliedSave="onSubjectsAppliedSave"
            @onSubjectsAppliedBack="onSubjectsAppliedBack"
            v-if="stage == 5"
            :subjectsApplied="subjectsApplied"
          ></ms3HkdseSubjectsApplied>
        </div>
        <div v-if="formType == 4">
          <msStudentParticular
            ref="studentParticularForm"
            @studentParticularSaveAndContinue="studentParticularSaveAndContinue"
            @studentParticularSave="studentParticularSave"
            v-if="stage == 1"
            :studentParticular="studentParticular"
          ></msStudentParticular>
   
          <msPersonalBackground
            v-if="stage == 2"
            :personalBackground="personalBackground"
          ></msPersonalBackground>
           <studentPerformance
            v-if="stage == 2"
            :eventStatusId='eventStatusId'
            :applicationDetail="applicationDetail"
            ref="studentPerformance"
            :studentPerformance="studentPerformance"
          ></studentPerformance>
          <msParentParticular
            v-if="stage == 2"
            ref="parentParticular"
            :parentParticulars="parentParticularData"
          ></msParentParticular>
          <msDeclaration
            :declaration="declaration"
            @personalBackgroundSaveAndContinue="
              personalBackgroundSaveAndContinue
            "
            @personalBackgroundSave="personalBackgroundSave"
            @personalBackgroundBack="personalBackgroundBack"
            v-if="stage == 2"
          ></msDeclaration>
          <msStudentFiles
            @onStudentFilesSaveAndContinue="onStudentFilesSaveAndContinue"
            @onStudentFilesSave="onStudentFilesSave"
            @onStudentFilesBack="onStudentFilesBack"
            v-if="stage == 3"
            :studentFiles="studentFiles"
          ></msStudentFiles>
          <msQuestionnaire
            @onQuestionnaireSaveAndContinue="onQuestionnaireSaveAndContinue"
            @onQuestionnaireSave="onQuestionnaireSave"
            @onQuestionnaireBack="onQuestionnaireBack"
            v-if="stage == 4"
            :questionnaire="questionnaire"
          ></msQuestionnaire>
          <msApplicantLanguage
            v-if="stage == 5"
            :applicantLanguage="applicantLanguage"
          ></msApplicantLanguage>
          <msSubjectsApplied
            @onSubjectsAppliedSaveAndSubmit="onSubjectsAppliedSaveAndSubmit"
            @onSubjectsAppliedSave="onSubjectsAppliedSave"
            @onSubjectsAppliedBack="onSubjectsAppliedBack"
            v-if="stage == 5"
            :subjectsApplied="subjectsApplied"
          ></msSubjectsApplied>
        </div>
        <div v-if="formType == 5">
          <msIBDPStudentParticular
            ref="studentParticularForm"
            @studentParticularSaveAndContinue="studentParticularSaveAndContinue"
            @studentParticularSave="studentParticularSave"
            v-if="stage == 1"
            :studentParticular="studentParticular"
          ></msIBDPStudentParticular>
       
          <msIBDPPersonalBackground
            v-if="stage == 2"
            :personalBackground="personalBackground"
          ></msIBDPPersonalBackground>
           <studentPerformance
            v-if="stage == 2"
            :eventStatusId='eventStatusId'
            :applicationDetail="applicationDetail"
            ref="studentPerformance"
            :studentPerformance="studentPerformance"
          ></studentPerformance>
          <msIBDPParentParticular
            v-if="stage == 2"
            ref="parentParticular"
            :parentParticulars="parentParticularData"
          ></msIBDPParentParticular>
          <msIBDPDeclaration
            :declaration="declaration"
            @personalBackgroundSaveAndContinue="
              personalBackgroundSaveAndContinue
            "
            @personalBackgroundSave="personalBackgroundSave"
            @personalBackgroundBack="personalBackgroundBack"
            v-if="stage == 2"
          ></msIBDPDeclaration>
          <msIBDPStudentFiles
            @onStudentFilesSaveAndContinue="onStudentFilesSaveAndContinue"
            @onStudentFilesSave="onStudentFilesSave"
            @onStudentFilesBack="onStudentFilesBack"
            v-if="stage == 3"
            :studentFiles="studentFiles"
          ></msIBDPStudentFiles>
          <msIBDPQuestionnaire
            @onQuestionnaireSaveAndContinue="onQuestionnaireSaveAndContinue"
            @onQuestionnaireSave="onQuestionnaireSave"
            @onQuestionnaireBack="onQuestionnaireBack"
            v-if="stage == 4"
            :questionnaire="questionnaire"
          ></msIBDPQuestionnaire>
          <msIBDPApplicantLanguage
            v-if="stage == 5"
            :applicantLanguage="applicantLanguage"
          ></msIBDPApplicantLanguage>
          <msIBDPSubjectsApplied
            @onSubjectsAppliedSaveAndSubmit="onSubjectsAppliedSaveAndSubmit"
            @onSubjectsAppliedSave="onSubjectsAppliedSave"
            @onSubjectsAppliedBack="onSubjectsAppliedBack"
            v-if="stage == 5"
            :subjectsApplied="subjectsApplied"
          ></msIBDPSubjectsApplied>
        </div>
        
      </div>
      <copyrightCard></copyrightCard>
    </div>
    <loadingDialog :centerDialogVisible="loadingDialogVisible"></loadingDialog>
    <loadingSlotDialog :centerDialogVisible="centerDialogVisible">
      <div class="dialog-title">提示</div>
      <div class="dialog-text">
        請確認以上資料是否正確，如需修改請按“取消”鍵，如資料正確請按“確定”後存儲及繼續申請流程。
      </div>
      <div>
        <el-button type="warning" @click="onConfirmCenter"> 確定</el-button>
        <el-button @click="onCancelCenter"> 取消</el-button>
      </div>
    </loadingSlotDialog>
    <loadingSlotDialog :centerDialogVisible="titleCenterDialogVisible">
      <div class="dialog-title">提示</div>
      <div class="dialog-text">
        <p>(1)請確認以上提交的文件是否正確，如需修改請按”取消”鍵，並重新上載文件。</p>
        <p>(2)如暫時未能提交文件，可按”儲存”鍵保存申請資料，並離開平台。當預備好文件後，可重新登入平台，於”我的申請”內按”修改”，並提交文件。 請注意，在「儲存」狀況下的申請將不作為正式申請，直至申請人繳交申請費用為止。</p>
        <p>(3)   ** 請注意，如提交文件正確，按”確定”後，所有資料及上載文件將不能更改。 請確認以上提交的文件是否正確，確認提交後，將需要繳交入學申請費用以完成入學申請程序。</p>
      </div>
      <div>
        <el-button type="warning" @click="onTitleConfirmCenter">
          確定</el-button
        >
        <el-button @click="onTitleCancelCenter"> 取消</el-button>
      </div>
    </loadingSlotDialog>
  </div>
</template>

<script>
import applicationFormat from "@/utils/applicationFormat";
import loadingSlotDialog from "@/components/loadingSlotDialog";
import loadingDialog from "@/components/loadingDialog";
import {
  addApplication,
  addApplicationSubmitFormRequests,
  addApplicationFinishUploadFileFillingFormRequests,
  addApplicationFillingFormRequests,
  addApplicationFinishFillingFormRequests,
} from "@/api/parent/application";
import copyrightCard from "@/components/copyrightCard";
import admissions from "@/components/admissions";
import studentPerformance from "@/components/studentPerformance";

import fsStudentParticular from "@/components/fs1/studentParticular";
import fsParentParticular from "@/components/fs1/parentParticular";
import fsPersonalBackground from "@/components/fs1/personalBackground";
import fsStudentFiles from "@/components/fs1/studentFiles";
import fsDeclaration from "@/components/fs1/declaration";

import fsInterimPersonalBackground from "@/components/fsInterim/personalBackground";
import fsInterimStudentParticular from "@/components/fsInterim/studentParticular";
import fsInterimParentParticular from "@/components/fsInterim/parentParticular";
import fsInterimDeclaration from "@/components/fsInterim/declaration";
import fsInterimStudentFiles from "@/components/fsInterim/studentFiles";

import ms1PersonalBackground from "@/components/ms1/personalBackground";
import ms1StudentParticular from "@/components/ms1/studentParticular";
import ms1ParentParticular from "@/components/ms1/parentParticular";
import ms1Declaration from "@/components/ms1/declaration";
import ms1StudentFiles from "@/components/ms1/studentFiles";

import ds1PersonalBackground from "@/components/ds1/personalBackground";
import ds1StudentParticular from "@/components/ds1/studentParticular";
import ds1ParentParticular from "@/components/ds1/parentParticular";
import ds1Declaration from "@/components/ds1/declaration";
import ds1StudentFiles from "@/components/ds1/studentFiles";

import ds2PersonalBackground from "@/components/ds2/personalBackground";
import ds2StudentParticular from "@/components/ds2/studentParticular";
import ds2ParentParticular from "@/components/ds2/parentParticular";
import ds2Declaration from "@/components/ds2/declaration";
import ds2StudentFiles from "@/components/ds2/studentFiles";

import fs2PersonalBackground from "@/components/fs2/personalBackground";
import fs2StudentParticular from "@/components/fs2/studentParticular";
import fs2ParentParticular from "@/components/fs2/parentParticular";
import fs2Declaration from "@/components/fs2/declaration";
import fs2StudentFiles from "@/components/fs2/studentFiles";

import ds3StudentParticular from "@/components/ds3/studentParticular";
import ds3ParentParticular from "@/components/ds3/parentParticular";
import ds3PersonalBackground from "@/components/ds3/personalBackground";
import ds3StudentFiles from "@/components/ds3/studentFiles";
import ds3Declaration from "@/components/ds3/declaration";

import ds4StudentParticular from "@/components/ds4/studentParticular";
import ds4ParentParticular from "@/components/ds4/parentParticular";
import ds4PersonalBackground from "@/components/ds4/personalBackground";
import ds4StudentFiles from "@/components/ds4/studentFiles";
import ds4Declaration from "@/components/ds4/declaration";

import ds5StudentParticular from "@/components/ds5/studentParticular";
import ds5ParentParticular from "@/components/ds5/parentParticular";
import ds5PersonalBackground from "@/components/ds5/personalBackground";
import ds5StudentFiles from "@/components/ds5/studentFiles";
import ds5Declaration from "@/components/ds5/declaration";

import msStudentParticular from "@/components/ms/studentParticular";
import msParentParticular from "@/components/ms/parentParticular";
import msPersonalBackground from "@/components/ms/personalBackground";
import msStudentFiles from "@/components/ms/studentFiles";
import msDeclaration from "@/components/ms/declaration";
import msQuestionnaire from "@/components/ms/questionnaire";
import msApplicantLanguage from "@/components/ms/applicantLanguage";
import msSubjectsApplied from "@/components/ms/subjectsApplied";

import ms3HkdseStudentParticular from "@/components/ms3Hkdse/studentParticular";
import ms3HkdseParentParticular from "@/components/ms3Hkdse/parentParticular";
import ms3HkdsePersonalBackground from "@/components/ms3Hkdse/personalBackground";
import ms3HkdseStudentFiles from "@/components/ms3Hkdse/studentFiles";
import ms3HkdseDeclaration from "@/components/ms3Hkdse/declaration";
import ms3HkdseQuestionnaire from "@/components/ms3Hkdse/questionnaire";
import ms3HkdseApplicantLanguage from "@/components/ms3Hkdse/applicantLanguage";
import ms3HkdseSubjectsApplied from "@/components/ms3Hkdse/subjectsApplied";

import msIBDPStudentParticular from "@/components/msIBDP/studentParticular";
import msIBDPParentParticular from "@/components/msIBDP/parentParticular";
import msIBDPPersonalBackground from "@/components/msIBDP/personalBackground";
import msIBDPStudentFiles from "@/components/msIBDP/studentFiles";
import msIBDPDeclaration from "@/components/msIBDP/declaration";
import msIBDPQuestionnaire from "@/components/msIBDP/questionnaire";
import msIBDPApplicantLanguage from "@/components/msIBDP/applicantLanguage";
import msIBDPSubjectsApplied from "@/components/msIBDP/subjectsApplied";

export default {
  mixins: [applicationFormat],
  components: {
    loadingDialog,
    loadingSlotDialog,
    copyrightCard,
    admissions,
    studentPerformance,
    
    ms1StudentParticular,
    ms1PersonalBackground,
    ms1ParentParticular,
    ms1Declaration,
    ms1StudentFiles,

    ds1StudentParticular,
    ds1PersonalBackground,
    ds1ParentParticular,
    ds1Declaration,
    ds1StudentFiles,

    ds2StudentParticular,
    ds2PersonalBackground,
    ds2ParentParticular,
    ds2Declaration,
    ds2StudentFiles,

    fsInterimStudentParticular,
    fsInterimPersonalBackground,
    fsInterimParentParticular,
    fsInterimDeclaration,
    fsInterimStudentFiles,

    fs2StudentParticular,
    fs2PersonalBackground,
    fs2ParentParticular,
    fs2Declaration,
    fs2StudentFiles,
    
    fsDeclaration,
    fsStudentFiles,
    fsPersonalBackground,
    fsParentParticular,
    fsStudentParticular,

    ds3Declaration,
    ds3StudentFiles,
    ds3PersonalBackground,
    ds3ParentParticular,
    ds3StudentParticular,

    ds5Declaration,
    ds5StudentFiles,
    ds5PersonalBackground,
    ds5ParentParticular,
    ds5StudentParticular,

    msDeclaration,
    msStudentFiles,
    msPersonalBackground,
    msParentParticular,
    msStudentParticular,
    msQuestionnaire,
    msApplicantLanguage,
    msSubjectsApplied,

    ms3HkdseDeclaration,
    ms3HkdseStudentFiles,
    ms3HkdsePersonalBackground,
    ms3HkdseParentParticular,
    ms3HkdseStudentParticular,
    ms3HkdseQuestionnaire,
    ms3HkdseApplicantLanguage,
    ms3HkdseSubjectsApplied,

    msIBDPDeclaration,
    msIBDPStudentFiles,
    msIBDPPersonalBackground,
    msIBDPParentParticular,
    msIBDPStudentParticular,
    msIBDPQuestionnaire,
    msIBDPApplicantLanguage,
    msIBDPSubjectsApplied,

    ds4Declaration,
    ds4StudentFiles,
    ds4PersonalBackground,
    ds4ParentParticular,
    ds4StudentParticular,
  },
  props: {
    eventStatusDetail:{
      type: Object,
      default: () => {},
    },
    applicationDetail:{
      type: Object,
      default: () => {},
    },
    applicationEditId: {
      type: Number,
      default: 0,
    },
    eventStatusId: {
      type: Number,
      default: 0,
    },
    formType: {
      type: Number,
      default: 0,
    },
    isEdit: {
      type: Boolean,
      default: false,
    },
  },
  watch:{
    applicationDetail:{
        handler(val){
          if(val && this.isEdit == true){
             this.applicationId = this.applicationEditId
             this.$store.dispatch("setStage", 1);
             this.intFormData(val)
          }
        },
        deep:true
    },
    eventStatusDetail:{
        handler(val){
          if(val){
            this.setLevelApplyingFor();
          }
        },
        deep:true,
        immediate:true
    },
  },
  computed: {
    stage() {
      return this.$store.getters.stage;
    },
  },
  destroyed() {
    this.$store.dispatch("setStage", 0);
  },
  data() {
    return {
      isChangeSubjects:true,
      isSub: false,
      applicationId:0,
      centerDialogVisible: false,
      loadingDialogVisible: false,
      titleCenterDialogVisible: false,
    };
  },
  methods: {
    intFormData(v){
         this.studentParticular = JSON.parse(
          this.componentMethods(v.components, 0)
        );
        this.parentParticularData.parentParticulars = JSON.parse(
          this.componentMethods(v.components, 1)
        );
        this.personalBackground = JSON.parse(
          this.componentMethods(v.components, 2)
        );
        this.studentFiles = JSON.parse(
          this.componentMethods(v.components, 3)
        );
        this.questionnaire.questionnaires = JSON.parse(
          this.componentMethods(v.components, 4)
        );
        this.applicantLanguage.applicantLanguages = JSON.parse(
          this.componentMethods(v.components, 5)
        );
        this.subjectsApplied = JSON.parse(
          this.componentMethods(v.components, 6)
        );
        this.declaration = JSON.parse(
          this.componentMethods(v.components, 7)
        );
        this.studentPerformance = JSON.parse(
          this.componentMethods(v.components, 8)
        );
        this.$forceUpdate();
    },
    componentMethods(components, type) {
      return components.filter((v) => {
        return v.type == type;
      })[0].value;
    },
    async addApplicationFillingFormRequests() {
      this.loadingDialogVisible = true
      await addApplicationFillingFormRequests(this.applicationId, this.getFromData())
      .then(() => {})
      .finally(() => {
         this.loadingDialogVisible = false
      })
    },
    async addApplicationFinishFillingFormRequests() {
      this.loadingDialogVisible = true
     await addApplicationFinishFillingFormRequests(this.applicationId, this.getFromData())
     .then(() => {})
     .finally(() => {
         this.loadingDialogVisible = false
      })
    },
    async addApplicationFinishUploadFileFillingFormRequests() {
      this.loadingDialogVisible = true
      await addApplicationFinishUploadFileFillingFormRequests(
        this.applicationId,
        this.getFromData()
      ).finally(() => {
         this.loadingDialogVisible = false
      })
    },
    async addApplicationSubmitFormRequests() {
      this.loadingDialogVisible = true
      await addApplicationSubmitFormRequests(this.applicationId, this.getFromData())
      .then(() => {
        if(this.isEdit){
          if (this.isSub && this.applicationDetail.status !== 3) {
            this.$router.push({ path: `/parent/message/${this.applicationId}` });
          } else {
            this.$router.push({ path: `/parent/application` });
          }
        }else{
          if (this.isSub) {
            this.$router.push({ path: `/parent/message/${this.applicationId}` });
          } else {
            this.$router.push({ path: `/parent/application` });
          }
        }
       
        this.backTop()
      }).finally(() => {
         this.loadingDialogVisible = false
      })
    },
    getFromData(){
      let from = [
         {
          type: 8,
          value: JSON.stringify(this.studentPerformance),
        },
        {
          type: 7,
          value: JSON.stringify(this.declaration),
        },
        {
          type: 0,
          value: JSON.stringify(this.studentParticular),
        },
        {
          type: 1,
          value: JSON.stringify(this.parentParticularData.parentParticulars),
        },
        {
          type: 2,
          value: JSON.stringify(this.personalBackground),
        },
        {
          type: 3,
          value: JSON.stringify(this.studentFiles),
        },
        {
          type: 4,
          value: JSON.stringify(this.questionnaire.questionnaires),
        },
        {
          type: 5,
          value: JSON.stringify(this.applicantLanguage.applicantLanguages),
        },
        {
          type: 6,
          value: JSON.stringify(this.subjectsApplied),
        },
      ];
      return from
    },
    addApplication() {
      let from = {
        eventStatusId: this.eventStatusId,
      };
      addApplication(from).then((v) => {
        this.applicationId = v.data.id;
        this.addApplicationFillingFormRequests();
      });
    },
    onAddApplication() {
      if (this.isEdit == false) {
        this.addApplication();
      } else {
        this.addApplicationFillingFormRequests();
      }
    },
    onProceed() {
      this.$store.dispatch("setStage", 1);
      this.backTop()
    },
    studentParticularSave() {
      this.$refs.studentParticularForm.$refs.studentParticularForm.validate((valid) => {
          if (valid) {
            this.onAddApplication();
            this.$router.push({ path: `/parent/application` });
            this.backTop()
          } else {
            this.getScrollIntoView()

            return false;
          }
        }
      );
    },
    studentParticularSaveAndContinue() {
      this.$refs.studentParticularForm.$refs.studentParticularForm.validate((valid) => {
          if (valid) {
            this.onAddApplication();
            this.$store.dispatch("setStage", 2);
            this.backTop()
          } else {
            this.getScrollIntoView()
            return false;
          }
        }
      );
    },
    personalBackgroundBack() {
      this.$store.dispatch("setStage", 1);
      this.backTop()
    },
    async personalBackgroundSave() {
      if(this.formType == 0){
        await this.addApplicationFinishFillingFormRequests();
        this.$router.push({ path: `/parent/application` });
        this.backTop()
      }else{
          this.$refs.studentPerformance.$refs.studentPerformance.validate((valid)=>{
              if(valid){
                this.addApplicationFinishFillingFormRequests();
                this.$router.push({ path: `/parent/application` });
                this.backTop()
              }else {
                this.getScrollIntoView()
                return false;
              }
          })
      }
    },
    async onConfirmCenter() {
      await this.addApplicationFinishFillingFormRequests();
      this.centerDialogVisible = false;
      this.$store.dispatch("setStage", 3);
      this.backTop()
    },
    onCancelCenter() {
      this.centerDialogVisible = false;
    },
    personalBackgroundSaveAndContinue() {
      if(this.formType ==0){
          this.$refs.parentParticular.$refs.form.validate((valid)=>{
              if(valid){
                this.centerDialogVisible = true;
              }else{
                this.getScrollIntoView()
              }
          })
      }else{
          let studentValid = false
          let parentValid = false
          this.$refs.studentPerformance.$refs.studentPerformance.validate((valid)=>{
            if(valid){
              studentValid = true
            }else{
              this.getScrollIntoView()
            }
          })
          this.$refs.parentParticular.$refs.form.validate((valid)=>{
              if(valid){
                parentValid = true;
              }else{
                this.getScrollIntoView()
              }
          })
          if(studentValid && parentValid){
            this.centerDialogVisible = true;
          }
      }
    },
    onStudentFilesBack() {
      this.$store.dispatch("setStage", 2);
      this.backTop()
    },
    async onStudentFilesSave() {
      await this.addApplicationFinishUploadFileFillingFormRequests();
      this.$router.push({ path: `/parent/application` });
      this.backTop()
    },
    async onStudentFilesSaveAndContinue() {
      await this.addApplicationFinishUploadFileFillingFormRequests();
      this.$store.dispatch("setStage", 4);
      this.backTop()
    },
    onStudentFilesSaveAndSubmit() {
      this.isSub = true
      this.titleCenterDialogVisible = true;
    },
    onTitleConfirmCenter() {
      this.addApplicationSubmitFormRequests();
      this.titleCenterDialogVisible = false;
    },
    onTitleCancelCenter() {
      this.titleCenterDialogVisible = false;
    },
    onQuestionnaireBack() {
      this.$store.dispatch("setStage", 3);
      this.backTop()
    },
    async onQuestionnaireSave() {
      this.isSub = false;
     await  this.addApplicationFillingFormRequests();
      this.$router.push({ path: `/parent/application` });
      this.backTop()
    },
    async onQuestionnaireSaveAndContinue() {
      this.isSub = false;
      await this.addApplicationFillingFormRequests();
      this.$store.dispatch("setStage", 5);
      this.backTop()
    },
    onSubjectsAppliedBack() {
      this.$store.dispatch("setStage", 4);
      this.backTop()
    },
    async onSubjectsAppliedSave() {
      if(this.formType == 4 || this.formType == 11){
          await this.setElectives()
      }
      if(this.formType == 5){
          await this.setIs()
      }
      if(this.isChangeSubjects){
      this.isSub = false;
      await this.addApplicationFillingFormRequests();
      this.$router.push({ path: `/parent/application` });
      this.backTop()
      }
    },
    async onSubjectsAppliedSaveAndSubmit() {
      if(this.formType == 4 || this.formType == 11){
          await this.setElectives()
      }
      if(this.formType == 5){
          await this.setIs()
      }
      if(this.isChangeSubjects){
      this.isSub = true;
      this.titleCenterDialogVisible = true;
      }
    },
    getScrollIntoView(){
       this.$nextTick(() => {
              const element = document.querySelectorAll(".is-error")[0];
              element.scrollIntoView({
                behavior: "smooth",
                block: "center",
              });
            });
    },
    setLevelApplyingFor() {
      if (this.formType == 0) {
        this.studentParticular.levelApplyingFor = 0;
      } else if (this.formType == 1) {
        this.studentParticular.levelApplyingFor = 1;
      } else if (this.formType == 2) {
        this.studentParticular.levelApplyingFor = 5;
      } else if (this.formType == 3) {
        this.studentParticular.levelApplyingFor = 6;
      } else if (this.formType == 4) {
        this.studentParticular.levelApplyingFor = 8;
      } else if (this.formType == 5) {
        this.studentParticular.levelApplyingFor = 10;
      } else if (this.formType == 7) {
        this.studentParticular.levelApplyingFor = 2;
      } else if (this.formType == 8) {
        this.studentParticular.levelApplyingFor = 3;
      } else if (this.formType == 9) {
        this.studentParticular.levelApplyingFor = 4;
      } else if (this.formType == 10) {
        this.studentParticular.levelApplyingFor = 7;
      } else if (this.formType == 11) {
        this.studentParticular.levelApplyingFor = 9;
      } else if (this.formType == 6){
        this.studentParticular.levelApplyingFor = 11;
      }
      this.$forceUpdate();
    },
    isFormTypeFinish() {
      let isForm;
      if (this.formType == 5 || this.formType == 4 || this.formType == 11) {
        isForm = true;
      } else {
        isForm = false;
      }
      return isForm;
    },
    backTop() {
            document.body.scrollTop = 0
            document.documentElement.scrollTop = 0
    },
    setElectives(){
      this.isChangeSubjects = true;
      let eletiveLength = this.subjectsApplied.eletives.length;
      if(eletiveLength<3 || eletiveLength>4){
        this.$message.error("請選擇三或四個選修科目");
        this.isChangeSubjects = false;
        return
      }
    },
    setIs() {
      this.isChangeSubjects = true;
      let selectedHigherLevelLength = this.subjectsApplied.otherSubjects.filter(
        (v) => {
          return v.isSelectedHigherLevel == true;
        }
      ).length;
      let selectedStandardLevelLength = this.subjectsApplied.otherSubjects.filter((v) => {
          return v.isSelectedStandardLevel == true;
        }).length;
      let groupType3 = this.subjectsApplied.otherSubjects.filter((v) => {
        return (
          v.groupType == 2 &&
          (v.isSelectedStandardLevel || v.isSelectedHigherLevel)
        );
      }).length;
      let groupType4 = this.subjectsApplied.otherSubjects.filter((v) => {
        return (
          v.groupType == 3 &&
          (v.isSelectedStandardLevel || v.isSelectedHigherLevel)
        );
      }).length;
      let groupType5 = this.subjectsApplied.otherSubjects.filter((v) => {
        return (
          v.groupType == 4 &&
          (v.isSelectedStandardLevel || v.isSelectedHigherLevel)
        );
      }).length;
      let groupType6 = this.subjectsApplied.otherSubjects.filter((v) => {
        return (
          v.groupType == 5 &&
          (v.isSelectedStandardLevel || v.isSelectedHigherLevel)
        );
      }).length;
      if ( selectedHigherLevelLength != 3) {
        //弹出消息
        this.$message.error("請選擇三個高級課程");
        this.isChangeSubjects = false;
        return;
      }
      if ( selectedStandardLevelLength != 3) {
        this.$message.error("請選擇三個標準課程");
        this.isChangeSubjects = false;
        return;
      }
      if (groupType5 == 0) {
        this.$message.error("請選擇Group5 一門課程");
        this.isChangeSubjects = false;
        return;
      }
      if (groupType6 == 0) {
        if (groupType4 < 2 && groupType3 < 2) {
          this.$message.error("請多選Group3一門課程或Group4一門課");
          this.isChangeSubjects = false;
          return;
        }
      }
      if (groupType4 == 0 || groupType3 == 0) {
        this.$message.error("請選擇Group3一門課程或Group4一門課");
        this.isChangeSubjects = false;
        return;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.application-detail {
  background-color: #fff;
  padding-top: 3.75rem;
}
.application-content {
  padding: 0 3.75rem;
}
.el-breadcrumb {
  margin: 1.875rem 0;
}
.dialog-title {
  font-size: 1.25rem;
}
.dialog-text {
  font-size: 1rem;
}
.applicationDetail-title{
  position: relative;
}
.registrationNo{
  text-align: left;
  font-size: 1rem;
  padding: 0 3.75rem;
  color: #000;
}
::v-deep {
  .el-breadcrumb__item:first-child .el-breadcrumb__inner {
    color: #0064ed;
  }
}
@media (min-width: $phoneMinWidth) and (max-width: $phoneMaxWidth) {
  .application-content {
    padding: 0 0.625rem;
  }
  .fs-title {
    font-size: 1.125rem;
  }
}
</style>